import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    justifyContent: 'space-between',
    height: theme.spacing(7),
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row nowrap',
    flex: '0 0 auto',
    textTransform: 'uppercase',
    padding: theme.spacing(1.25),
    borderRadius: theme.spacing(1.25),
    backgroundColor: theme.palette.background.paper,
    cursor: 'pointer',
    border: `${theme.spacing(0.125)} solid ${theme.palette.background.paper}`,

    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    },
  },

  avatar: {
    padding: theme.spacing(0, 1),
  },

  userName: {
    lineHeight: 1,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    letterSpacing: '0.05em',
    fontFamily: '"Bebas Neue"',
    fontSize: theme.spacing(2.25),
    textOverflow: 'ellipsis',
    maxWidth: theme.spacing(25),
  },

  highlight: {
    color: theme.palette.success.light,
    backgroundColor: 'transparent',
    padding: theme.spacing(0),
  },
}));
